/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { EconomicBranchControllerService } from './services/economic-branch-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    EconomicBranchControllerService,
    ApiConfiguration
  ],
})
export class CustomersEconomicbranchModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersEconomicbranchModule> {
    return {
      ngModule: CustomersEconomicbranchModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersEconomicbranchModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersEconomicbranchModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
